import {
  streamerDealList,
  streamerDealApprove,
  streamerDealReject,
  dealClickList,
  dealClickMarkConverted,
  dealClickMarkNoSale,
  dealBroadcastClickList,
  dealsPendingBroadcasts,
} from '@/services/dealsAdmin.service'

export default {
  namespaced: true,
  state: {
    applications: { data: [], meta: { pagination: { total: 0 } } },
    applicationsStatus: 'init',
    clicks: { data: [], meta: { pagination: { total: 0 } } },
    clicksStatus: 'init',
    broadcastClicks: { data: [], meta: { pagination: { total: 0 } } },
    broadcastClicksStatus: 'init',
    pendingBroadcasts: [],
    pendingBroadcastsStatus: 'init',
  },
  getters: {
    getApplications: s => s.applications,
    getApplicationsStatus: s => s.applicationsStatus,
    getClicks: s => s.clicks,
    getClicksStatus: s => s.clicksStatus,
    getBroadcastClicks: s => s.broadcastClicks,
    getBroadcastClicksStatus: s => s.broadcastClicksStatus,
    getPendingBroadcasts: s => s.pendingBroadcasts,
    getPendingBroadcastsStatus: s => s.pendingBroadcastsStatus,
  },
  mutations: {
    SET_APPLICATIONS(state, value) { state.applications = value },
    SET_APPLICATIONS_STATUS(state, value) { state.applicationsStatus = value },
    SET_CLICKS(state, value) { state.clicks = value },
    SET_CLICKS_STATUS(state, value) { state.clicksStatus = value },
    SET_BROADCAST_CLICKS(state, value) { state.broadcastClicks = value },
    SET_BROADCAST_CLICKS_STATUS(state, value) { state.broadcastClicksStatus = value },
    SET_PENDING_BROADCASTS(state, value) { state.pendingBroadcasts = value },
    SET_PENDING_BROADCASTS_STATUS(state, value) { state.pendingBroadcastsStatus = value },
  },
  actions: {
    async fetchApplications({ commit }, params) {
      commit('SET_APPLICATIONS_STATUS', 'pending')
      try {
        const { data } = await streamerDealList(params)
        commit('SET_APPLICATIONS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_APPLICATIONS_STATUS', 'init')
      }
    },

    async approveApplication({ dispatch }, { id, page, perPage, status }) {
      await streamerDealApprove(id)
      dispatch('fetchApplications', { page, per_page: perPage, status })
    },

    async rejectApplication({ dispatch }, { id, reason, page, perPage, status }) {
      await streamerDealReject(id, { reason })
      dispatch('fetchApplications', { page, per_page: perPage, status })
    },

    async fetchClicks({ commit }, params) {
      commit('SET_CLICKS_STATUS', 'pending')
      try {
        const { data } = await dealClickList(params)
        commit('SET_CLICKS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_CLICKS_STATUS', 'init')
      }
    },

    async markClickConverted({ dispatch }, { id, form, page, perPage, status }) {
      await dealClickMarkConverted(id, form)
      dispatch('fetchClicks', { page, per_page: perPage, status })
    },

    async markClickNoSale({ dispatch }, { id, page, perPage, status }) {
      await dealClickMarkNoSale(id)
      dispatch('fetchClicks', { page, per_page: perPage, status })
    },

    async fetchBroadcastClicks({ commit }, params) {
      commit('SET_BROADCAST_CLICKS_STATUS', 'pending')
      try {
        const { data } = await dealBroadcastClickList(params)
        commit('SET_BROADCAST_CLICKS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_BROADCAST_CLICKS_STATUS', 'init')
      }
    },

    async fetchPendingBroadcasts({ commit }, params) {
      commit('SET_PENDING_BROADCASTS_STATUS', 'pending')
      try {
        const { data } = await dealsPendingBroadcasts(params)
        commit('SET_PENDING_BROADCASTS', data.data || [])
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_PENDING_BROADCASTS_STATUS', 'init')
      }
    },
  },
}
